// extracted by mini-css-extract-plugin
export default {"cell-side__text":"v8V8I"};